import DynamicTitleWithTooltip from "../components/DynamicTitleWithTooltip";
import Form from "./Form";
import { Edit as RaEdit } from "react-admin";
import React from "react";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";

const getEmailTemplatesTitle = (record, translate) =>
  `${translate("resources.email-template.name")} ${record.id} (${record.name})`;

const Edit = (props) => {
  const id = props.id?.toString(); // ID della risorsa
  useManageOpenEditTabs(props.resource, id);

  return (
    <RaEdit
      {...props}
      undoable={false}
      title={<DynamicTitleWithTooltip getTitle={getEmailTemplatesTitle} />}
    >
      <Form />
    </RaEdit>
  );
};

export default Edit;
